import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import Moment from 'moment';

// Components
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import CsvConditionDialog from '../components/modals/CsvConditionDialog';
import { Information } from '../components/modals/common';

// Services
import { UserProfileService } from '../services/UserProfiles';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { OutputCsvProcessingsService } from '../services/OutputCsvProcessings';

// Utilities
import {
  REQUEST_PARAMS,
  HEADER_CONSTANTS,
  WORK_TYPE,
  CSV_PROCESS_STATUS,
  CSV_DOWNLOAD_STATUS,
} from '../utilities/constants';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { MasterPageHeader } from '../components/PageHeader';

export default class CSVList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: 'CSVデータ出力',
      dialogShow: false,
      dialogData: {
        csv_type: 1,
        from_date: '',
        to_date: '',
        company_branches: [],
        fields: [],
      },
      errorDialogShow: false,
      isLoading: true,
      isOpened: false,
      listLoaded: false,
      isPermitted: false,
      outputCsvProcessings: [],
      params: {},
      total: 0,
    };

    this.getList = this.getList.bind(this);
    this.getCondition = this.getCondition.bind(this);
    this.setSearchCondition = this.setSearchCondition.bind(this);
    this.clearConditions = this.clearConditions.bind(this);
    this.processDownload = this.processDownload.bind(this);
  }

  checkPermission = () => {
    const userId = LocalStorageService.getItem('user_id');
    UserProfileService.show(userId, {}).then(response => {
      if (!response.result) {
        return;
      } else {
        const useOutputCsvProcessingFlg =
          response.data.entities.user_profile.use_output_csv_processing_flg;
        if (!useOutputCsvProcessingFlg) {
          this.setState({
            errorDialogShow: true,
          });
        } else {
          this.setState({
            isPermitted: true,
          });
        }
      }
    });
  };

  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  getList = notify => {
    if (this.state.listLoaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    if (this.state.isPermitted === false) {
      return;
    }

    let params = {
      ...this.state.params,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.outputCsvProcessings),
      isQuiet: true,
    };

    OutputCsvProcessingsService.list(params).then(response => {
      if (!response.result) {
        return;
      }
      if (response.result) {
        let { outputCsvProcessings } = _.cloneDeep(this.state);
        const data = response.data.entities.output_csv_processings;
        if (_.isEmpty(data)) {
          this.setState({ listLoaded: true, total: response.data.total });
        } else {
          if (params.offset === _.size(outputCsvProcessings)) {
            outputCsvProcessings = _.concat(outputCsvProcessings, data);
          } else {
            outputCsvProcessings = data;
          }
          this.setState({
            outputCsvProcessings,
            listLoaded: false,
            total: response.data.total,
          });
        }
      }
      this.setState({ isLoading: false });
      notify();
    });
  };

  processDownload = async id => {
    try {
      const file = await OutputCsvProcessingsService.process(id);
      const data = file.data.entities.csv_url;
      this.setState(
        {
          isLoading: true,
          listLoaded: false,
          outputCsvProcessings: [],
        },
        () => {
          this.getList(() => {
            /*
             * NOTE BLDE_V2-26942
             * csvファイルのダウンロードを行うと一部の端末（2021/03/05現在はiPad）でダウンロードの確認ダイアログが表示される。
             * 確認ダイアログ表示中にAPIリクエストを行うとネットワークエラーが発生しリストが正常に取得できない。
             * そのためリスト取得後にcsvファイルダウンロードを行うように修正した。
             */
            window.location.href = data;
          });
        }
      );
    } catch (error) {
      const errorMessage = error.toString();
      console.error('CsvList', 'ネットワークエラーです', errorMessage);
      window.location.replace('/error-500');
      return false;
    }
  };

  componentDidMount() {
    this.checkPermission();
    this.getList(() => {});
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.isPermitted, this.state.isPermitted)) {
      this.getList(() => {});
    }
  }

  setSearchCondition = e => {
    let { name: paramName, value: paramValue } = e.target;
    let { params } = _.cloneDeep(this.state);
    if (
      paramName === 'download_status' &&
      _.has(params, 'download_status') &&
      params.download_status === 1
    ) {
      delete params.download_status;
      this.setState(
        {
          listLoaded: false,
          isLoading: true,
          outputCsvProcessings: [],
          params,
        },
        () => {
          this.getList(() => {});
        }
      );
    } else {
      this.setState(
        {
          listLoaded: false,
          isLoading: true,
          outputCsvProcessings: [],
          params: {
            ...this.state.params,
            [paramName]: Number(paramValue),
          },
        },
        () => {
          this.getList(() => {});
        }
      );
    }
  };

  clearConditions = () => {
    const params = {};
    this.setState(
      { isLoading: true, listLoaded: false, params, outputCsvProcessings: [] },
      () => {
        this.getList(() => {});
      }
    );
  };

  getCondition = id => {
    OutputCsvProcessingsService.info(id).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        dialogData: response.data.entities.output_csv_processing_condition,
        dialogShow: true,
      });
    });
  };

  render() {
    const {
      dialogData,
      dialogShow,
      isOpened,
      isPermitted,
      pageTitle,
      params,
      total,
    } = this.state;

    return (
      <div className='master-slide-view show CsvList'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - {pageTitle}
          </title>
        </Helmet>
        <div className='master-slide-view__view'>
          {isPermitted && (
            <React.Fragment>
              <MasterPageHeader
                title={pageTitle}
                onClose={() => masterSlideLoader.close()}
              />
              <div id='scroll-parent' className='contruction-slide-view__body'>
                <div className='contruction-detail-view'>
                  <div className='contruction-detail-view__sidemenu'>
                    <ul className='contruction-navi-list'>
                      <li className='contruction-navi-list__item'>
                        <a
                          className={
                            'line-list line-list--contruction-navi-list'
                          }
                          onClick={() => {
                            masterSlideLoader.show('CsvRequest', {
                              state: {},
                            });
                          }}
                        >
                          CSV出力依頼
                        </a>
                      </li>
                      <li className='contruction-navi-list__item'>
                        <a
                          className='line-list line-list--contruction-navi-list select'
                          onClick={() => {
                            masterSlideLoader.show('CsvList', {
                              state: {},
                            });
                          }}
                        >
                          CSVダウンロード
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                    <div className='csv-list' id='infinityscroll-target'>
                      <div className='csv-list__heading'>
                        <div className='csv-form__description'>
                          <p>
                            CSVファイルをダウンロードするには、まず「CSV出力依頼」を行ってください。
                          </p>
                          <p>
                            出力が完了しましたら下記の一覧からダウンロードすることができます。
                          </p>
                        </div>
                        <div className='search-form'>
                          <div className='search-form__header'>
                            <div className='search-form__title'>
                              検索条件（検索結果
                              <span className='bold'>{total}</span>
                              件)
                            </div>
                            <button
                              id='accordion-toggle'
                              className={
                                isOpened
                                  ? 'accordion__btn show'
                                  : 'accordion__btn'
                              }
                              onClick={() => this.handleSearchFormShow()}
                            />
                            <button
                              className='btn-text--sm'
                              onClick={() => this.clearConditions()}
                            >
                              検索条件クリア
                            </button>
                          </div>
                          <div
                            id='search-form-accordion'
                            className={
                              isOpened ? 'accordion show' : 'accordion'
                            }
                          >
                            <div className='search-form__body'>
                              <div className='form form--search-form'>
                                <div className='form__group flex-wrap'>
                                  <div className='form-element'>
                                    <div className='form-element__label'>
                                      <span className='label'>対象情報</span>
                                    </div>
                                    <div className='form-element__list'>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='radio-type-1'
                                          className='radio'
                                        >
                                          <input
                                            id='radio-type-1'
                                            name='csv_type'
                                            type='radio'
                                            value={WORK_TYPE.WORK_SCHEDULE.ID}
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.csv_type ===
                                              WORK_TYPE.WORK_SCHEDULE.ID
                                            }
                                          />
                                          <i className='i-2x' />
                                          <span>
                                            {WORK_TYPE.WORK_SCHEDULE.NAME}
                                          </span>
                                        </label>
                                      </div>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='radio-type-2'
                                          className='radio'
                                        >
                                          <input
                                            id='radio-type-2'
                                            name='csv_type'
                                            type='radio'
                                            value={WORK_TYPE.WORK_RESULT.ID}
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.csv_type ===
                                              WORK_TYPE.WORK_RESULT.ID
                                            }
                                          />
                                          <i className='i-2x' />
                                          <span>
                                            {WORK_TYPE.WORK_RESULT.NAME}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='form-element'>
                                    <div className='form-element__label'>
                                      <span className='label'>ステータス</span>
                                    </div>
                                    <div className='form-element__list'>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='radio-status-1'
                                          className='radio'
                                        >
                                          <input
                                            id='radio-status-1'
                                            name='process_status'
                                            type='radio'
                                            value={
                                              CSV_PROCESS_STATUS.AVAILABLE.ID
                                            }
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.process_status ===
                                              CSV_PROCESS_STATUS.AVAILABLE.ID
                                            }
                                          />
                                          <i className='i-2x' />
                                          <span>ダウンロード可能</span>
                                        </label>
                                      </div>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='radio-status-2'
                                          className='radio'
                                        >
                                          <input
                                            id='radio-status-2'
                                            name='process_status'
                                            type='radio'
                                            value={
                                              CSV_PROCESS_STATUS.PROCESSING.ID
                                            }
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.process_status ===
                                              CSV_PROCESS_STATUS.PROCESSING.ID
                                            }
                                          />
                                          <i className='i-2x' />
                                          <span>処理中</span>
                                        </label>
                                      </div>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='radio-status-3'
                                          className='radio'
                                        >
                                          <input
                                            id='radio-status-3'
                                            name='process_status'
                                            type='radio'
                                            value={CSV_PROCESS_STATUS.ERROR.ID}
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.process_status ===
                                              CSV_PROCESS_STATUS.ERROR.ID
                                            }
                                          />
                                          <i className='i-2x' />
                                          <span>エラー</span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='form-element'>
                                    <div className='form-element__label'>
                                      <span className='label'>
                                        ダウンロード状況
                                      </span>
                                    </div>
                                    <div className='form-element__list'>
                                      <div className='element__item'>
                                        <label
                                          htmlFor='check-dl-status-1'
                                          className='radio'
                                        >
                                          <input
                                            id='check-dl-status-1'
                                            name='download_status'
                                            type='checkbox'
                                            value={CSV_DOWNLOAD_STATUS.NEW.ID}
                                            onChange={e =>
                                              this.setSearchCondition(e)
                                            }
                                            checked={
                                              params.download_status ===
                                              CSV_DOWNLOAD_STATUS.NEW.ID
                                            }
                                          />
                                          <span>
                                            ダウンロード済のデータを非表示にする
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='csv-list__header'>
                          <p>※有効期限の切れたファイルは順次削除されます。</p>
                        </div>
                      </div>
                      <div>
                        <table className='data-table'>
                          <thead className='data-table__header'>
                            <tr>
                              <th className='data-table__head'>対象</th>
                              <th className='data-table__head'>ステータス</th>
                              <th className='data-table__head'>作成開始日時</th>
                              <th className='data-table__head'>作成終了日時</th>
                              <th className='data-table__head'>有効期限</th>
                              <th className='data-table__head'>抽出条件</th>
                              <th className='data-table__head'>
                                ダウンロード状況
                              </th>
                            </tr>
                          </thead>
                          <tbody className='table__group'>
                            {_.map(this.state.outputCsvProcessings, item => {
                              return (
                                <tr className='data-table__item' key={item.id}>
                                  <td className='data-table__cell data-table__cell--minimum'>
                                    {_.get(
                                      _.find(WORK_TYPE, type => {
                                        return type.ID === item.csv_type;
                                      }),
                                      'NAME'
                                    )}
                                  </td>
                                  <td className='data-table__cell data-table__cell--minimum'>
                                    {_.get(
                                      _.find(CSV_PROCESS_STATUS, status => {
                                        return (
                                          status.ID === item.process_status
                                        );
                                      }),
                                      'TEXT'
                                    )}
                                  </td>
                                  <td className='data-table__cell'>
                                    {!_.isNull(item.start_date)
                                      ? Moment(item.start_date).format(
                                          'YYYY/MM/DD HH:mm'
                                        )
                                      : ''}
                                  </td>
                                  <td className='data-table__cell'>
                                    {!_.isNull(item.end_date)
                                      ? Moment(item.end_date).format(
                                          'YYYY/MM/DD HH:mm'
                                        )
                                      : ''}
                                  </td>
                                  <td className='data-table__cell'>
                                    {!_.isNull(item.expiration_date)
                                      ? Moment(item.expiration_date).format(
                                          'YYYY/MM/DD HH:mm'
                                        )
                                      : ''}
                                  </td>
                                  <td className='data-table__cell'>
                                    <button
                                      className='btn--contained'
                                      type='button'
                                      onClick={() => {
                                        this.getCondition(item.id);
                                      }}
                                    >
                                      確認
                                    </button>
                                  </td>
                                  <td className='data-table__cell'>
                                    {/* {item.download_status} */}
                                    {item.process_status ===
                                    CSV_PROCESS_STATUS.PROCESSING.ID ? (
                                      <p>
                                        CSVを出力中です。しばらくお待ちください。
                                      </p>
                                    ) : item.process_status ===
                                      CSV_PROCESS_STATUS.AVAILABLE.ID ? (
                                      <button
                                        className={
                                          item.download_status ===
                                          CSV_DOWNLOAD_STATUS.NEW.ID
                                            ? 'btn'
                                            : 'btn--sub'
                                        }
                                        onClick={() => {
                                          this.processDownload(item.id);
                                        }}
                                        type='button'
                                      >
                                        {_.get(
                                          _.find(
                                            CSV_DOWNLOAD_STATUS,
                                            status => {
                                              return (
                                                status.ID ===
                                                item.download_status
                                              );
                                            }
                                          ),
                                          'TEXT'
                                        )}
                                      </button>
                                    ) : (
                                      item.process_status ===
                                        CSV_PROCESS_STATUS.ERROR.ID && (
                                        <p className='text--negative'>
                                          再度CSV出力依頼を行ってください。
                                        </p>
                                      )
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <InfinityScrollLoad
                          targetId={`infinityscroll-target`}
                          total={this.state.total}
                          isLoading={this.state.isLoading}
                          callback={this.getList}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        <CsvConditionDialog
          data={dialogData}
          visible={dialogShow}
          onClose={() => {
            this.setState({
              dialogShow: false,
            });
          }}
        />
        <Information
          message={messageUtility.getMessage('I-000-084')}
          buttonText={messageUtility.getMessage('I-000-085')}
          visible={this.state.errorDialogShow}
          onClose={() => {
            this.setState(
              {
                errorDialogShow: false,
              },
              () => {
                masterSlideLoader.close();
              }
            );
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CsvList.jsx